import { store } from '../redux/store';
import { autoLogout, checkSessionExpiry, setAuthentication } from '../redux/slices/authSlice';

class SessionService {
  constructor() {
    this.checkInterval = null;
    this.logoutTimer = null;
  }

  startSessionMonitoring() {
    this.stopSessionMonitoring();

    this.ensureLoginTime();

    this.checkInterval = setInterval(() => {
      const state = store.getState();
      if (state.auth.authenticated) {
        store.dispatch(checkSessionExpiry());

        const updatedState = store.getState();
        if (!updatedState.auth.authenticated) {
          this.handleSessionExpiry();
        }
      }
      // console.log('REMAINING TIME:', this.getRemainingTime());
    }, 5 * 60 * 1000);

    this.setLogoutTimer();
  }

  ensureLoginTime() {
    const state = store.getState();
    if (state.auth.authenticated && !state.auth.loginTime) {
      store.dispatch(setAuthentication(state.auth.authData));
    }
  }

  setLogoutTimer() {
    const state = store.getState();
    if (state.auth.loginTime && state.auth.authenticated) {
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - state.auth.loginTime;
      const sessionExpiry = 48 * 60 * 60 * 1000;
      const remainingTime = sessionExpiry - timeDifference;

      if (remainingTime > 0) {
        this.logoutTimer = setTimeout(() => {
          this.handleSessionExpiry();
        }, remainingTime);
      } else {
        this.handleSessionExpiry();
      }
    }
  }

  handleSessionExpiry() {
    this.stopSessionMonitoring();
    store.dispatch(autoLogout());
  }

  stopSessionMonitoring() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer);
      this.logoutTimer = null;
    }
  }

  getRemainingTime() {
    const state = store.getState();
    if (state.auth.loginTime && state.auth.authenticated) {
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - state.auth.loginTime;
      const sessionExpiry = 48 * 60 * 60 * 1000;
      const remainingTime = sessionExpiry - timeDifference;
      return remainingTime > 0 ? remainingTime : 0;
    }
    return 0;
  }
}

const sessionService = new SessionService();
export default sessionService;